import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfigService } from './shared/services/config.service'
import { ILogged } from './shared/interfaces/ILogged';
import { isMobile, isMobileXL } from './shared/utils/helpers';
import { LoggedService, getToken } from './shared/services/logged.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSelectionList } from '@angular/material/list';
import { MatSidenav } from '@angular/material/sidenav';
import { PrimeNGConfig } from 'primeng-lts/api';
import { Router,ActivatedRoute } from '@angular/router'
import { SidenavService } from './shared/services/sidenav.service';
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core';
import { UsuariosService } from './shared/services/usuarios.service';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit, AfterViewInit {

  @ViewChild('admLinks') admLinks: MatSelectionList;
  @ViewChild('cuentasLinks') cuentasLinks: MatSelectionList;
  @ViewChild('expansionPanelADM') expansionPanelADM: MatExpansionPanel;
  @ViewChild('expansionPanelCuentas') expansionPanelCuentas: MatExpansionPanel;
  @ViewChild('expansionPanelPedidos') expansionPanelPedidos: MatExpansionPanel;
  @ViewChild('expansionPanelProductos') expansionPanelProductos: MatExpansionPanel;
  @ViewChild('expansionPanelTablas') expansionPanelTablas: MatExpansionPanel;
  @ViewChild('expansionPanelReportes') expansionPanelReportes: MatExpansionPanel;
  @ViewChild('pedidosLinks') pedidosLinks: MatSelectionList;
  @ViewChild('productosLinks') productosLinks: MatSelectionList;
  @ViewChild('sideNav') public sideNav: MatSidenav;
  @ViewChild('tablasLinks') tablasLinks: MatSelectionList;
  isExpanded: boolean = false;
  panelOpenState = false;
  public closedsidenav: boolean
  public loading: boolean = false;
  public logged?: ILogged;
  public ngxspinnerFullScreen: boolean
  public primeraCarga: boolean = true;
  public title = 'Order2Go'
  public Mensajes:
    {
      LoginUsuario:
      {
        Bienvenido: string
      }
    }
  isCurrentRoute: boolean = false;

  public Etiquetas: {

    Ayuda: string;
    CambiarClave: string;
    CerrarSesion: string;
    IconoADM: string;
    IconoPedidos:string,
    IconoCuentas: string;
    IconoProductos: string;
    IconoTablas: string;
    IconoReportes: string
    LeyendaContacto: string
    MailContacto: string
    TituloApp: string
    TituloCerrarMenu: string
    ConfirmacionCotizacion:{
      Titulo:string,
      Path:string
    },
    CambioClave:{
      Titulo:string,
      Path:string
    },
    VerificarCuenta:{
      Titulo:string,
      Path:string
    },
    ConfirmarEmail:{
      Titulo:string,
      Path:string
    },
    Home: {
      Titulo: string
      Path: string
    },
    Usuarios: {
      Titulo: string
      Path: string
      ConfirmarEmail: {
        Titulo: string
        Path: string
      }
    }

  }
  public CondicionesDeUso: {
    Link: string
    Titulo: string
  }
  public PoliticaDePrivacidad: {
    Link: string
    Titulo: string
  }
  public PieDeImprenta: {
    Link: string
    Titulo: string
  }
  public PoliticaDeCookies: {
    Link: string
    Titulo: string
  }
  public DetallesTecnicos: {
    Link: string
    Titulo: string
  }
  public Bayer: string
  public linkcambio: { text: string; path: string }
  public linkHome: { text: string; path: string; icon: string; } = { text: "", path: "", icon: "", };
  public linkhome: Array<{ text: string; path: string; icon: string; index: number; idModulo: string; }> = []
  public links: Array<{ text: string; path: string }> = []
  subscription: Subscription

  constructor(
    private configService: ConfigService,
    private loggedService: LoggedService,
    private primeNGconfig: PrimeNGConfig,
    private router: Router,
    private sidenavService: SidenavService,
    private usuariosService: UsuariosService,
    translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    translateService.setDefaultLang('es');
    translateService.use('es');
    translateService.get("primeng").subscribe(res => this.primeNGconfig.setTranslation(res));
    this.loggedService.getLogged().subscribe((_logged: ILogged) => this.logged = _logged);
  }

  ngxSpinerFullScreen(fs: string): boolean {
    this.ngxSpinerFullScreen = JSON.parse(fs);
    return this.ngxspinnerFullScreen;
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sideNav);

  }
  currentRouteUrl: string;

  ngOnInit() 
  {
    this.currentRouteUrl = window.location.href;
    console.log('Current route URL:', this.currentRouteUrl);
    if (this.loggedService.validToken()) {
      this.loggedService.setLogged(getToken());
    }

    this.ngxspinnerFullScreen = true;
    this.Mensajes =
    {
      LoginUsuario:
      {
        Bienvenido: this.configService.mensajes.LoginUsuario.Bienvenido
      }
    }
    this.Etiquetas = {
      Ayuda: this.configService.etiquetas.Login.Ayuda,
      CambiarClave: this.configService.etiquetas.MenuUsuario.CambiarClave,
      CerrarSesion: this.configService.etiquetas.MenuUsuario.CerrarSesion,
      IconoADM: this.configService.etiquetas.IconoADM,
      IconoPedidos: this.configService.etiquetas.IconoPedidos,
      IconoCuentas: this.configService.etiquetas.IconoCuentas,
      IconoProductos: this.configService.etiquetas.IconoProductos,
      IconoTablas: this.configService.etiquetas.IconoTablas,
      IconoReportes: this.configService.etiquetas.IconoReportes,
      LeyendaContacto: this.configService.etiquetas.LeyendaContacto,
      MailContacto: this.configService.etiquetas.MailContacto,
      TituloApp: this.configService.etiquetas.TituloApp,
      TituloCerrarMenu: this.configService.etiquetas.TituloCerrarMenu,
      ConfirmacionCotizacion: {
        Titulo: this.configService.etiquetas.ConfirmacionCotizacion.Titulo,
        Path: this.configService.etiquetas.ConfirmacionCotizacion.Path
      },
      ConfirmarEmail: {
        Titulo: this.configService.etiquetas.ConfirmarEmail.Titulo,
        Path: this.configService.etiquetas.ConfirmarEmail.Path
      },
      CambioClave: {
        Titulo: this.configService.etiquetas.CambiarClave.Titulo,
        Path: this.configService.etiquetas.CambiarClave.Path
      },
      VerificarCuenta: {
        Titulo: this.configService.etiquetas.VerificarCuenta.Titulo,
        Path: this.configService.etiquetas.VerificarCuenta.Path
      },
      Home: {
        Titulo: this.configService.etiquetas.Home.Titulo,
        Path: this.configService.etiquetas.Home.Path
      },
      Usuarios: {
        Titulo: this.configService.etiquetas.Usuarios.Titulo,
        Path: this.configService.etiquetas.Usuarios.Path,
        ConfirmarEmail: {
          Titulo: this.configService.etiquetas.ConfirmarEmail.Titulo,
          Path: this.configService.etiquetas.ConfirmarEmail.Path
        }
      },
    }
    this.Bayer = this.configService.uri.Bayer

    this.CondicionesDeUso = {
      Titulo: this.configService.uri.CondicionesDeUso.Titulo,
      Link: this.configService.uri.CondicionesDeUso.Link,
    }
    this.PoliticaDePrivacidad = {
      Titulo: this.configService.uri.PoliticaDePrivacidad.Titulo,
      Link: this.configService.uri.PoliticaDePrivacidad.Link,
    }
    this.PieDeImprenta = {
      Titulo: this.configService.uri.PieDeImprenta.Titulo,
      Link: this.configService.uri.PieDeImprenta.Link,
    }
    this.PoliticaDeCookies = {
      Titulo: this.configService.uri.PoliticaDeCookies.Titulo,
      Link: this.configService.uri.PoliticaDeCookies.Link,
    }
    this.DetallesTecnicos = {
      Titulo: this.configService.uri.DetallesTecnicos.Titulo,
      Link: this.configService.uri.DetallesTecnicos.Link,
    }
    this.linkcambio = {
      text: this.configService.etiquetas.CambiarClave.Titulo,
      path: this.configService.etiquetas.CambiarClave.Path,
    }

    const paths = [
      this.Etiquetas.VerificarCuenta.Path,
      this.Etiquetas.ConfirmarEmail.Path,
      this.Etiquetas.CambioClave.Path,
      this.Etiquetas.ConfirmacionCotizacion.Path,
    ];
    this.isCurrentRoute = paths.some(path => this.currentRouteUrl.includes(path));
    // const nroCotizacion = this.activatedRoute.snapshot.queryParams['nroCotizacion'];
    // const token = this.activatedRoute.snapshot.queryParams['token'];

    // console.log('Número de cotización:', nroCotizacion);
    // console.log('Token:', token);
    if(!this.isCurrentRoute)
    {
      if (!this.isLogged()) {
        //this.router.navigateByUrl(this.configService.etiquetas.Login.Path);
        const currentUrl = this.currentRouteUrl; // Obtén la ruta actual
  this.router.navigate([this.configService.etiquetas.Login.Path], { queryParams: { redirectUrl: currentUrl } });

      }
    }

  }

  // goTo(link:any)
  // {
  //   this.isExpanded = false;
  //   window.open(link);
  // }


  isMobile() {
    return isMobile();
  }

  isMobileXL() {
    return isMobileXL();
  }

  isLogged() {
    return this.logged != null;
  }

  isNewUser() {
    if (this.logged != null) {
      return this.logged.newUser;
    }
    else {
      return false
    }
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}